interface IScreenTitleProps {
	title: string;
}

const ScreenTitle = (props: IScreenTitleProps) => {
	const { title } = props;

	return (
		<div className={'header-alt bg-auto 2xl:bg-contain bg-black bg-no-repeat'}>
			<div className={'h-full flex flex-col items-center py-12 sm:py-20 text-white text-4xl sm:text-5xl'}>
				<div className={'border-2 border-primary w-52 sm:w-64 my-4'}></div>
				{title}
			</div>
		</div>
	);
};

export default ScreenTitle;
